<template>
    <b-overlay :show="showOverlay">
        <b-embed type="iframe" @load="loaded" :src="src" :aspect="aspect" :allowfullscreen="allowfullscreen"></b-embed>
    </b-overlay>
</template>

<script>
export default {
    props: ["src", "aspect", "allowfullscreen"],
    data() {
        return {
            showOverlay: true
        };
    },
    methods: {
        loaded() {
            this.showOverlay = false;
        }
    }
}
</script>